import React from 'react';
import { TableItemActionsNew, Icons } from 'components';
import { Tooltip } from '@mui/material';

const columns = (navigate, setDialog, changeStateOfBranch, actionsList) => [
  {
    title: 'ردیف',
    field: 'num',
    filtering: false,
    sorting: false,
    align: 'center',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
  },
  {
    title: 'شناسه حساب',
    field: 'multiConfirmationSrv?.id',
    filtering: false,
    sorting: false,
    align: 'center',
    render: (rd) => (rd?.multiConfirmationSrv?.id ? rd?.multiConfirmationSrv?.id : '-'),
  },
  {
    title: 'حساب تفصیلی/دیجیتال',
    field: 'multiConfirmationSrv?.guildSrv?.name',
    filtering: false,
    sorting: false,
    align: 'center',
    render: (rd) =>
      rd?.multiConfirmationSrv?.guildSrv?.name || rd?.multiConfirmationSrv?.wallet?.name || '-',
  },
  {
    title: 'وضعیت حساب',
    filtering: false,
    sorting: false,
    align: 'center',
    field: 'multiConfirmationSrv?.enable',
    render: (rd) => (rd?.multiConfirmationSrv?.enable ? `فعال` : 'غیر فعال'),
  },
  {
    title: 'نوع تایید',
    filtering: false,
    sorting: false,
    align: 'center',
    render: (row) => <StatusConfirm row={row?.multiConfirmationSrv?.confirmToolCode} />,
  },
  {
    title: 'توضیحات',
    filtering: false,
    sorting: false,
    align: 'center',
    field: 'multiConfirmationSrv?.description',
    render: (rd) =>
      rd?.multiConfirmationSrv?.description ? (
        <Tooltip enterNextDelay={200} placement="right" title={rd.multiConfirmationSrv.description}>
          <div style={{ cursor: 'pointer' }}>
            {rd.multiConfirmationSrv.description.substring(0, 40) + '...'}
          </div>
        </Tooltip>
      ) : (
        '-'
      ),
  },
  ...(actionsList['contentListCartbleBtn'] ? [{


    title: 'عملیات',
    field: 'operationSmall',
    filtering: false,
    sorting: false,
    align: 'right',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
    render: (row) => (
      <TableItemActionsNew
        iconButton
        startIcon={<Icons icon="MoreHorizontal" color="#667585" size="20" />}
        title=""
        otherMenus={[
          {
            title: 'درخواست ها',
            isShow: true,
            onClick: () =>
              navigate(`/CartableRequest/List?cartableId=${row?.multiConfirmationSrv?.id}`, {
                state: row,
              }),
          },

        ]}
      />
    ),

  }] : []),
];
/**
 * بررسی میکند که آیا حداقل یک مورد از اکشن ها دسترسی دارد یا خیر که ستون عملیات را نشان دهد یا مخفی کند
 */

const StatusConfirm = ({ row }) => {
  return (
    <div>
      {row.map((item, index) => {
        return `${status[item]}  ${index != row.length - 1 ? ' - ' : ''}`;
      })}
    </div>
  );
};


const status = {
  MULTI_CONFIRMATION_VERIFY_TOOL_SMS: 'پیامک',
  MULTI_CONFIRMATION_VERIFY_TOOL_API: 'سرویس',
};

const generateData = (rows, query) => {
  return rows?.map?.((row, key) => ({
    num: query?.page * query?.pageSize + key + 1,
    ...row,
  }));
};

export { columns, generateData };
